import * as actionTypes from './actionTypes';
import Parse from '../../Parse';

const timeOut = 60 * 60;

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (userId, role) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        userId: userId,
        role: role
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    localStorage.removeItem('userId');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const setAuthTimeout = () => {
    return {
        type: actionTypes.SET_EXPIRED_TIME
    };
};

export const checkAuthTimeout = () => {
    return dispatch => {
        setTimeout(() => {
            Parse.User.logOut().then(() => {
                dispatch(logout());
            });
        }, timeOut * 1000);
        
        dispatch(setAuthTimeout());
    };
};

export const auth = (email, password) => {
    return dispatch => {
        dispatch(authStart());
        Parse.User.logIn(email, password).then(res => {
            const role = res.get('role');
            if(role === 'super_admin') {
                dispatch(authSuccess(res.id, role));
                dispatch(checkAuthTimeout());
            }
            else if(role === 'admin') {
                dispatch(authSuccess(res.id, role));
                dispatch(checkAuthTimeout());
            }
            else if(role === 'reseller') {
                dispatch(authSuccess(res.id, role));
                dispatch(checkAuthTimeout());  
            }
            else if(/partner_(\d+)/.test(role)) {
                dispatch(authSuccess(res.id, role));
                dispatch(checkAuthTimeout());  
            }
            else {
                dispatch(authFail({
                    message: 'Authentication Fail'
                }));    
            }
        })
        .catch(error => {
            dispatch(authFail(error));
        });
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = (expired) => {
    return dispatch => {
        const currentUser = Parse.User.current();
        if (currentUser) {
            const role = currentUser.get('role');
            if(role === 'admin') {
                dispatch(authSuccess(currentUser.id, role));
                if(!expired) {
                    dispatch(checkAuthTimeout());
                }
            }
            else if(role === 'reseller') {
                dispatch(authSuccess(currentUser.id, role));
                if(!expired) {
                    dispatch(checkAuthTimeout());
                }
            }
            else {
                dispatch(logout()); 
            }
        } else {
            dispatch(logout());
        }
    };
};